import {
    currentPageReducer,
    currentBrokerReducer,
    isBrokerFetchCompletedReducer,
    formReducer,
    listOfPagesReducer,
    isHeaderLogoRightSideVisible
} from "./data/reducers";
import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
    forms: formReducer,
    currentPage: currentPageReducer,
    listOfPages: listOfPagesReducer,
    currentBroker: currentBrokerReducer,
    isBrokerFetchCompleted: isBrokerFetchCompletedReducer,
    isHeaderLogoRightSideVisible: isHeaderLogoRightSideVisible
});

// TODO remove this soon as possible
export const StoreManager = configureStore({
    reducer: rootReducer
});
